import { action } from 'satcheljs';

// Toolbox height
export const initToolboxHeight = action('initToolboxHeight', (defaultHeight: number) => ({
    defaultHeight,
}));
export const setToolboxHeight = action('setToolboxHeight', (height: number) => ({ height }));
